define([
	"csi/view"
], function(csiView) {

	return {
		postActionBusinessPlanChildrenChanged: function(ac) {
			var view = csiView.getView("BPMarketPlans");
			if (view) view.refreshWidget();
		},

		postActionRefreshRates: function(ac) {
			var view = csiView.getView("ExchangeRates");
			if (view) view.refreshWidget();
		},

		onActionCommitedSupplierItem: function(ac) {
			//TA20687
			// to fetch CurrentRevision into the cache when aggregating the Master
			// (needed for <DependencyPath Path="Child:Committed/Child:SupplierItem/Child:CurrentRevision"/>)
			if(ac.getNode())
				ac.m_cache.getNode(ac.getNode().CurrentRevision, true);
		}
	};
});